// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2716": "cd9d354e4182","494": "4077578422d4","6863": "454c9f289029","8357": "dd422574e14d","8561": "f9cad78a6d35","9747": "b9c5d2e3b3b2",}[chunkId] + ".css"
}